import React, { useState, useEffect } from "react";

import MainLayout from "../../components/MainLayout";
import Cards from "../archive/containers/Cards";
import ComicItem from "../../components/ComicItem";
import Popup from "../../components/Popup";

import { useTranslation } from "react-i18next";

import { getComic } from "../../utils/databaseOperations";

import { useParams } from "react-router-dom";

import { getDomainWithLanguageURL } from "../../utils/languageFunctions";

import ClipLoader from "react-spinners/ClipLoader";



const ComicDetailPage = () => {

    const { t } = useTranslation();

    // Sacar el id de comicItem del URL
    const { id } = useParams();

    // State para el popup window
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [comicItem, setComicItem] = useState();
    const [comicLink, setComicLink] = useState("");


    // Fetch the comic that I will load later
    useEffect(() => {
        fetchComic();

    }, []);


    const fetchComic = async () => {

        let result = await getComic(id);

        console.log("executing !!!!");

        setComicItem(result);
    }


    const togglePopup = (link) => {  // Poner un parametro en esta funcion? Para pasar el link del Comic ???
        
        setIsPopupOpen(!isPopupOpen);
        setComicLink(link);
    };



    return <MainLayout>
        {isPopupOpen && <Popup handleClose={togglePopup} comicLink={comicLink} />} 

        {
            comicItem != null ? 
            (
                <section className="flex items-center flex-col max-w-4xl mx-auto py-4 gap-y-7">
                    <ComicItem item={comicItem} togglePopup={togglePopup} urlPart={getDomainWithLanguageURL()}/>
                </section>

            ) : (

                <ClipLoader
                color={"#2688ff"}
                loading={true}
                cssOverride={{
                    display: "block",
                    margin: "75px auto",
                    borderColor: "blue",
                }}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
                />
            )
        }

        <p className="mt-1 font-bold text-2xl" align="center">
            {t('Other Comics')}:
        </p>
        <Cards className="lg:grid-cols-5 grid-cols-4 max-w-6xl" excludeId={id} urlPart={getDomainWithLanguageURL()} />
    </MainLayout>
}; 

export default ComicDetailPage; 